/**
 * アバターに出す頭文字。出せないときは null を返す。
 *
 * 以前はここが "?" に落ちていた。名前が空のアカウントは普通にあるので
 * (team.server.ts が name を `user.name || ""` で埋めている)、
 * 何も悪いことをしていない人のアイコンが疑問符になっていた。
 * 疑問符は「あなたが誰だか分からない」と読めるので、出す先が違う。
 *
 * null のときは呼び出し側がゆめさく先生のアイコンを出す。
 * PageHeader は元から常にそのアイコンなので、見た目も揃う。
 */
export function avatarInitials(userName?: string | null): string | null {
  if (!userName) return null;

  const initials = userName
    .trim()
    .split(/\s+/)
    // [0] だと絵文字や一部の漢字がサロゲートペアの片側だけになり、
    // 壊れた文字が出る。コードポイントで切る
    .map((word) => Array.from(word)[0] ?? "")
    .join("")
    .slice(0, 2);

  return initials.length > 0 ? initials : null;
}
